import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import BookingApi from "Services/Booking";

const BookingDeleteModal = ({ openDialog, bookingId, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!bookingId) {
      dispatch(
        showSnackbar({
          message: "Booking ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    BookingApi.deleteBooking(bookingId).then(
      () => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Booking deleted successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose(true);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while deleting booking",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      }
    );
  };

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="xs">
      <DialogTitle>{"Are you sure delete this booking ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Booking ID: {bookingId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Disagree</Button>
        <Button onClick={handleDelete} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BookingDeleteModal;
